import {DataGroup} from 'vis-timeline/esnext';

const MACHINES: DataGroup[] = [
    {
        id: 'm11',
        className: 'ametras-timeline__group',
        content: 'G38911<br>AR 60<br>FWI',
        title: 'Maschinendetails anzeigen'
    },
    {
        id: 'm12',
        className: 'ametras-timeline__group',
        content: '1.2<br>D05',
        title: 'Maschinendetails anzeigen'
    },
    {
        id: 'm21',
        className: 'ametras-timeline__group',
        content: 'G33881<br>AR 60 E<br>FWI',
        title: 'Maschinendetails anzeigen'
    }
];

export { MACHINES };
